import {useEffect, useState} from "react";


export const useSupportPWA = () => {

    const [supportsPWA, setSupportsPWA] = useState(false);
    const [supportPWAIos, setSupportPWAIos] = useState(false)
    const [promptInstall, setPromptInstall] = useState(null);
    useEffect(() => {
        const handler = e => {
            e.preventDefault();
            console.log("we are being triggered :D");
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);
        const userAgent = window.navigator.userAgent.toLowerCase()
        const isIos = /iphone|ipad|ipod/.test(userAgent)
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
        if (isIos && !isInStandaloneMode()) {
            setSupportPWAIos(true)
        }
        return () => window.removeEventListener("transitionend", handler);
    }, []);

    const installPWA = evt => {
        evt.preventDefault();
        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    };

    return {installPWA, supportsPWA, supportPWAIos}
}